import type {CustomerResponseBodyV2} from '@dms/api/customer';
import {getCustomerPhoneNumber} from '@dms/shared';

import type {Nullish} from 'shared/web';

export function getWhatsAppPhoneNumber(customer: CustomerResponseBodyV2 | Nullish) {
  const phoneNumber = getCustomerPhoneNumber(customer);

  if (!phoneNumber?.startsWith('+')) {
    return null;
  }

  return phoneNumber.replace(/\s+/g, '').replace('+', '');
}
